import { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "components/ui/dialog";
import { Button } from "components/ui/button";
import { useQueryClient } from "@tanstack/react-query";
import { useUserInfo } from "../../../../context/user";
import { useDeleteAgent, agentsKeys } from "../../../../queries/agents";

// Rendered OUTSIDE the card's DropdownMenu: Radix menu content is positioned
// with a CSS transform, which re-anchors position:fixed descendants to the
// menu box and clips them (CU-86carbtuf). The shadcn Dialog portals to <body>.
function DeleteModal({ open, onOpenChange, item, handleRefresh }) {
  const queryClient = useQueryClient();
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const deleteAgent = useDeleteAgent();
  const [deleting, setDeleting] = useState(false);

  const deleteAssistant = async () => {
    setDeleting(true);
    try {
      await deleteAgent.mutateAsync({
        _id: item._id,
        assistant_id: item.assistant_id,
      });
      queryClient.invalidateQueries({
        queryKey: agentsKeys.list(userInfo?._id, userActiveLocation?.id),
      });
      onOpenChange(false);
      handleRefresh();
    } catch (error) {
      console.error("Error deleting assistant:", error);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Delete agent</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete{" "}
          <span className="font-medium text-foreground">
            {`"${item?.assistant_name}"`}
          </span>
          ? This can&apos;t be undone.
        </p>
        <DialogFooter>
          <Button
            variant="outline"
            disabled={deleting}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            disabled={deleting}
            onClick={deleteAssistant}
          >
            {deleting ? "Deleting…" : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

DeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  item: PropTypes.object,
  handleRefresh: PropTypes.func,
};

export default DeleteModal;
